$(document).ready(function(){

	// -- functions --
	function scrollToSection($el, $this){
		$('html, body').animate({
			scrollTop: $el.offset().top - $('.header').outerHeight()
		}, 'slow');
		$this.find('.icon--plus').focus();
	}
	
	function toggleAria($this){
		$this.parent('.col').attr('aria-expanded', function (i, attr){
	    return attr == 'true' ? 'false' : 'true';
		});
		$this.parent('.col').attr('aria-haspopup', function (i, attr){
	    return attr == 'true' ? 'false' : 'true';
		});
	}

	
	// -- section about --
	$('.section__about .cta').on('click', function(){
		if ($(this).parent('.col').hasClass('open')) {
			$('.section__about .col').removeClass('open').removeClass('hide');
		} else {
			$('.section__about .col').removeClass('open').addClass('hide');
			$(this).parent('.col').removeClass('hide').addClass('open');
			scrollToSection($('.section__about'), $(this));
		}
		toggleAria($(this));
	});

	
	// -- section submit --
	$('.section__submit .cta--submit').on('click', function(){
		$(this).fadeOut();
		$('.section__submit .details').addClass('open');
		scrollToSection($('.section__submit'), $(this).next('.details'));
	});
	$('.section__submit .btn--close').on('click', function(){
		$('.section__submit .details').removeClass('open');
		$('.section__submit .cta--submit').fadeIn().focus();
	});

});